export default class {
	constructor(options) {
		const scopeThis = this;
		this.defaults = {
			$el: null,
		};
		this.options = {};
		this.imgIndex = 0;
		this.cycleTime = 2000;
		Object.assign(this.options, this.defaults, options);

		this.namespace = "CHIPS_Autocycle";
		if (this.options.$el) {
			this.$el = this.options.$el;

			this.init(true);
		}
	}

	init(bool) {
		if (bool) {
			if (!this.$el.classList.contains("ui-init")) {
				this.$el.classList.add("ui-init");

				this.initUI();
			}
		} else {
		}
	}

	initUI() {
		this.cycleImages();
	}

	cycleImages() {
		const scopeThis = this;
		const imgs = this.$el.querySelectorAll("figure");
		imgs.forEach((img) => {
			img.classList.remove("active");
		});
		imgs[this.imgIndex].classList.add("active");
		this.imgIndex++;
		if (this.imgIndex >= imgs.length) {
			this.imgIndex = 0;
		}
		clearTimeout(this.timer);
		this.timer = setTimeout(function () {
			scopeThis.cycleImages();
		}, this.cycleTime);
	}
}
